import { PropsWithChildren, useMemo, useState } from 'react';
import { createSafeContext } from '@mews/framework';
import { GenerateContractProps } from '../types';

interface GenerateContractContextProps {
    reservationId?: string;
    customerId?: string;
    handleSetCurrentReservationId?: (reservationId: string) => void;
}

export const { GenerateContractContextProvider, useGenerateContractContext } = createSafeContext<
    'GenerateContractContext',
    GenerateContractContextProps
>('GenerateContractContext');

export const GenerateContractProvider = ({
    children,
    customerId,
    reservationId,
}: PropsWithChildren<GenerateContractProps>) => {
    const [currentReservationId, setCurrentReservationId] = useState(reservationId);

    const value = useMemo(() => {
        const handleSetCurrentReservationId = (id: string) => {
            if (id === currentReservationId) return;
            setCurrentReservationId(id);
        };

        return {
            reservationId: currentReservationId,
            customerId,
            handleSetCurrentReservationId,
        };
    }, [customerId, currentReservationId]);

    return <GenerateContractContextProvider value={value}>{children}</GenerateContractContextProvider>;
};
